// src/components/store/sections/newsletter/NewsletterV58AuroraislandOceanCyan.tsx
"use client";

import React from "react";
import DynamicNewsletterVariant from "./DynamicNewsletterVariant";

export default function NewsletterV58AuroraislandOceanCyan(props: any) {
  return (
    <DynamicNewsletterVariant
      variantNumber={58}
      archKey="aurora_island"
      archLabel="Frosted Aurora Island"
      palName="OceanCyan"
      grad="from-cyan-500 via-sky-500 to-blue-700"
      lightBg="bg-cyan-50"
      textCol="text-cyan-700"
      borderCol="border-cyan-200"
      btnCls="bg-blue-600 hover:bg-blue-700"
      hexCol="#06b6d4"
      {...props}
    />
  );
}
